import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import t from 'prop-types'

import {
  Loading,
  Notifications,
  Chart,
} from 'components/UI'

class FloorTimeline extends Component {
  render () {
    const {
      loading,
      error,
      floor,
    } = this.props.data

    if (error) return <Notifications.Error message={error.message} />
    if (loading) return <Loading height={280} />

    return (
      <Chart.Timeline
        data={floor.averageTemps}
        dataKey1='roomTemp'
        dataKey2='radTemp'
        onZoom={this.props.onZoom}
      />
    )
  }
}

FloorTimeline.propTypes = {
  onZoom: t.func.isRequired,
}

const FloorTimelineQuery = gql`
  query FloorTimelineQuery($id: Int!, $from: String!, $to: String!) {
    floor(id: $id) {
      averageTemps(from: $from to: $to) {
        roomTemp
        radTemp
        UTCTimestamp
      }
    }
  }
`
export default graphql(FloorTimelineQuery, {
  options: ({ floorId, from, to }) => ({
    variables: {
      id: floorId,
      from: String(from),
      to: String(to),
    },
    notifyOnNetworkStatusChange: true,
  }),
})(FloorTimeline)



// WEBPACK FOOTER //
// ./src/components/Floor/FloorTimeline.jsx